export default __webpack_public_path__ + "static/media/fileReward.87f0e33d.png";